import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

const useInvalidateCountAndSearch = () => {
    const queryClient = useQueryClient()

    const invalidateCountAndSearch = useCallback(() => {
          const promises = Promise.all([
              queryClient.invalidateQueries({queryKey: ["items", "search"]}),
              queryClient.invalidateQueries({queryKey: ["items", "search-count"]})
          ]);

          return { promises }
      }, [queryClient],
    );

    return {
        invalidateCountAndSearch
    }

}

export { useInvalidateCountAndSearch }
